export default "__VITE_ASSET__c7bf90d4__"